import React from "react";
import "./T_Details_Card.css";
import { Link } from "react-router-dom";

const T_Details_Card = ({
    orderId,
    onClick,
    no_of_items,
    date,
    showTrackOrder,
    type,
    price,
    subtext,
    track_order_text,
    baseLike,
}) => {

    const isCredit = type === "Credit";

    const formattedDate = date
        ? new Date(date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        })
        : "";

    return (
        <section className="T_Details_Card">

            {/* TOP SECTION */}
            <div className="top_section">
                <p className="order_id">
                    Ref ID #{orderId || "N/A"}
                </p>

                <div className="date_text_div">
                    <p className="date_text">{formattedDate}</p>
                </div>
            </div>

            {/* MIDDLE SECTION */}
            {no_of_items && (
                <div className="middle_section">
                    <p className="black_text">{no_of_items} Items</p>

                    {showTrackOrder && (
                        <p className="track_order_text" onClick={onClick}>
                            {track_order_text}
                        </p>
                    )}
                </div>
            )}

            {/* BOTTOM SECTION */}
            <div className="bottom_section">
                <p className="black_text">

                    {/* + / - sign */}
                    {/* <span className={isCredit ? "Credit" : "Debit"}>
                        {isCredit ? "+ " : "- "}
                        {price}
                    </span> */}

                    {/* description */}
                    {subtext && (
                        <span className={`${type} subtext`}>
                            {" "}
                            {subtext}
                        </span>
                    )}
                </p>

                <span className={isCredit ? "Credit" : "Debit"}>
                    {isCredit ? "+ " : "- "}
                    {price}
                </span>
                {/* {subtext && (
                    <span className={`${type} subtext`}>
                        {" "}
                        {subtext}
                    </span>
                )} */}
                {/* {baseLike && (
                    <Link to={baseLike}>
                        <p className="view_details_text">View Details</p>
                    </Link>
                )} */}
            </div>
        </section>
    );
};

export default T_Details_Card;
